import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage, defineMessages } from 'react-intl';

import { hasGamesStarted, isFixtureLive } from '#src/lib/so5.ts';

import type { FixtureOverviewTitle_so5Fixture } from './__generated__/index.graphql.ts';

const messages = defineMessages({
  warmingUp: {
    defaultMessage: 'Warming Up',
  },
  noRewards: {
    defaultMessage: 'No rewards - yet!',
  },
  rightOnTrack: {
    defaultMessage: 'Right on track!',
  },
  victory: {
    defaultMessage: 'Victory!',
  },
  unlucky: {
    defaultMessage: 'Unlucky, not this time.',
  },
});

type Props = { so5Fixture: FixtureOverviewTitle_so5Fixture };

export const FixtureOverviewTitle = ({ so5Fixture }: Props) => {
  const isLive = isFixtureLive(so5Fixture);
  const hasRewards = so5Fixture.myEligibleOrSo5Rewards.length > 0;
  const hasSomeGameStarted = so5Fixture.mySo5Lineups.some(hasGamesStarted);

  let message: MessageDescriptor;
  if (isLive && !hasSomeGameStarted) {
    message = messages.warmingUp;
  } else if (isLive && !hasRewards) {
    message = messages.noRewards;
  } else if (isLive) {
    message = messages.rightOnTrack;
  } else if (hasRewards) {
    message = messages.victory;
  } else {
    message = messages.unlucky;
  }

  return <FormattedMessage {...message} />;
};

FixtureOverviewTitle.fragments = {
  so5Fixture: gql`
    fragment FixtureOverviewTitle_so5Fixture on So5Fixture {
      slug
      ...isFixtureLive_so5Fixture
      mySo5Lineups {
        id
        ...hasGamesStarted_so5Lineup
      }
      myEligibleOrSo5Rewards {
        ... on So5Reward {
          slug
        }
        ... on So5RewardConfig {
          id
          ranks
        }
      }
    }
    ${hasGamesStarted.fragments.so5Lineup}
    ${isFixtureLive.fragments.so5Fixture}
  ` as TypedDocumentNode<FixtureOverviewTitle_so5Fixture>,
};
